import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Spin, Modal, Form, Input, message } from 'antd'
import { createEstimateAction, estimateSelector, clearState } from '../../../store/estimate'

const messageProjectKey = 'add_new_estimate'

const AddEstimateModal = ({ projectId, showModal, onChancel, isFetching, onFinish }) => {
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const formRef = useRef()
  const { isFetching: isEstimateFetching, isAddSuccess } = useSelector(estimateSelector)

  const onChancelClick = () => {
    form.resetFields()
    onChancel()
  }
  const onFinishCallback = (data) => {
    dispatch(
      createEstimateAction({
        data: {
          description: data.description,
          project: projectId,
        },
        file: form.getFieldInstance('file').input.files[0],
      })
    )
    onFinish()
  }

  useEffect(() => {
    if (!isEstimateFetching && isAddSuccess) {
      message.success({ content: 'Смета добавлен успешно', key: messageProjectKey })
      form.resetFields()
      dispatch(clearState())
      onChancel()
    }
  }, [isEstimateFetching, isAddSuccess, form, dispatch, onChancel])

  return (
    <Modal
      title="Загрузить смету"
      visible={showModal}
      onCancel={onChancelClick}
      footer={[
        <Button key="back" onClick={onChancelClick}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          Добавить
        </Button>,
      ]}
    >
      <Spin spinning={isFetching}>
        <Form
          ref={formRef}
          name="new-project"
          autoComplete="off"
          layout="vertical"
          onFinish={onFinishCallback}
          // onFinishFailed={onFinishFailed}
          form={form}
          size="large"
        >
          <Form.Item label="Описание" name="description">
            <Input />
          </Form.Item>
          <Form.Item label="Смета" name="file">
            <Input type="file" />
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  )
}

export default AddEstimateModal
